import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover } from 'antd';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;

class Top10Wording extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}



	render() {
		const { loading, userTheme,opensearchTop10WordingList } = this.props;

		cc_data = opensearchTop10WordingList || [];
		cc_data = cc_data.sort((a,b)=>a.doc_count-b.doc_count);
		let dataset = [];
		cc_data.forEach((d) => {
			let temp = [];
			temp.push(d.key,d.doc_count);
			dataset.push(temp);
		});
		const option = {
			dataset: {
				source: dataset
			  },
			grid: { containLabel: true },
			toolbox: {
				showTitle: false,
			  show: true,
			  orient: 'vertical',
			  left: 'right',
			  top: 'center',
			  feature: {
				mark: { show: true },
				dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
				magicType: { show: true, type: ['line'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
				restore: { show: true, title:'Refresh' },
				
			  }
			},
			tooltip: {
			  trigger: 'axis',
			  axisPointer: {
				type: 'shadow'
			  }
			},
			xAxis: { type: 'value' },
			yAxis: { type: 'category' },
			series: [
			  {
				type: 'bar'
			  }
			]
		  };
		// const columns = [
		// 	{
		// 	  title: 'Ad Location',
		// 	  dataIndex: 'key',
			  
		// 	},
		// 	{
		// 	  title: 'Count',
		// 	  dataIndex: 'doc_count',
			  
		// 	}
		//   ];
		let csv_data = cc_data.sort((a,b)=>b.doc_count-a.doc_count);
		return (
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Most Searched Wordings  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='Top10Wording').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={csv_data.map(c => ({ wording: c.key , count: c.doc_count }))} target="_blank" filename={"Most Searched Wordings.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	{/* <Table style={{ height: 350, width: '100%' }} theme={userTheme} dataSource={cc_data} columns={columns} /> */}
					<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} />
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchTop10WordingList: state.search.opensearchTop10WordingList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top10Wording));
